import { Badge, Link, TableProps } from '@amzn/awsui-components-core';
import React from 'react';
import { McpConfig } from 'src/components/context/AppContextModels';

export const MCP_SERVERS_TABLE_COLUMNS: TableProps.ColumnDefinition<McpConfig>[] = [
  {
    id: 'name',
    header: 'Name',
    cell: (item) => <Link href={`/admin/manage-mcp-server/${item.id}`}>{item.name}</Link>,
    sortingField: 'name'
  },
  {
    id: 'id',
    header: 'ID (Slug)',
    cell: (item) => item.id
  },
  {
    id: 'description',
    header: 'Description',
    cell: (item) => item.description || '-'
  },
  {
    id: 'isFeatured',
    header: 'Featured',
    cell: (item) => (item.isFeatured ? <Badge color="green">Yes</Badge> : <Badge color="grey">No</Badge>)
  },
  {
    id: 'tools',
    header: 'Skills',
    cell: (item) => (item.toolGroups || []).reduce((sum, g) => sum + g.tools.length, 0)
  },
  {
    id: 'contacts',
    header: 'Contacts',
    cell: (item) => item.contacts?.length || 0
  },
  {
    id: 'updatedAt',
    header: 'Last Updated',
    cell: (item) => item.updatedAt || '-',
    sortingField: 'updatedAt'
  }
];
